import React from "react";
import { Layout, theme } from "antd";
import PageHeader from "./PageHeader";
import { PageSidenav } from "./PageSidenav";
import { Outlet } from "react-router-dom";
import { Footer } from "antd/es/layout/layout";
import { FooterSection } from "../../Users/FooterSection";
import SubscriptionPromoBar from "../add_bars/SubscriptionPromoBar";
import { useUserInfo } from "../../contexts/userInfo";
import { hasFreeTrialExpired } from "../../helper/hasFreeTrialExpired";
import { getFreeTrialDaysLeft } from "../../helper/getFreeTrialsDayLeft";
import { useSubscriptions } from "../../contexts/subscriptionsContext";
import moment from "moment";

const { Content } = Layout;

const PageLayout = () => {
  const {
    token: { borderRadiusLG },
  } = theme.useToken();

  const { userInfo } = useUserInfo();
  const { purchasedSubscription } = useSubscriptions();

  const createdAt = userInfo?.created_at;
  const trialDaysLeft = createdAt ? getFreeTrialDaysLeft(createdAt) : 0;
  const trialExpired = createdAt ? hasFreeTrialExpired(createdAt) : true;

  const subscription = purchasedSubscription || null;
  const subscriptionIsActive = subscription?.is_active === 1;

  return (
    <div className="page-layout flex flex-col min-h-screen">
      {/* MAIN AREA (Sidebar + Content) */}
      <div className="page-layout-body flex flex-1 min-h-0">
        {/* SIDEBAR */}
        <PageSidenav />

        {/* RIGHT SECTION */}
        <div className="page-layout-main flex flex-col flex-1">
          <PageHeader />

          {!subscriptionIsActive && trialDaysLeft > 0 && (
            <SubscriptionPromoBar
              trialDaysLeft={trialDaysLeft}
              subscriptionIsActive={subscriptionIsActive}
            />
          )}

          <Content className="page-layout-content flex-1">
            <div
              className="page-layout-inner"
              style={{
                padding: '0 10px 20px 10px',
                background: "#F4F2F9",
                borderRadius: borderRadiusLG,
                minHeight: "100%",
              }}
            >
              <Outlet />
            </div>
          </Content>
        </div>
      </div>

      {/* FOOTER ALWAYS AT BOTTOM + FULL WIDTH */}
      <Footer className="page-footer" style={{ padding: 0, marginTop: 1 }}>
        <FooterSection />
      </Footer>
    </div>
  );
};

export default PageLayout;
